import PropTypes from 'prop-types';

export const propTypes = {
  locale: PropTypes.string,
  cid: PropTypes.string,
  market: PropTypes.string,
  abbrBrand: PropTypes.string,
  criticalCss: PropTypes.arrayOf(PropTypes.object),
  highPriorityEvents: PropTypes.array,
};

export const nodeDivisions = {
  division : 'division',
  subDivision : 'sub-division',
}
